import React from 'react';
import Breadcrumb from '../../Shared/BreadCumb';
import {BUTTON_LINE_ICON} from '../../Shared/Constants';
import { MagnifyingGlassIcon, 
PlusCircleIcon, 
PencilIcon
 } from '@heroicons/react/20/solid';
import { getCranes } from './services/cranes';
import ClipLoader from "react-spinners/ClipLoader";

class CranesList extends React.Component {
    
    BreadcrumbPages = [
        { name: 'Administracion', href: '#', current: false },
        { name: 'Lista de Gruas', href: '#', current: true },
    ]

    constructor(props) {
            super(props);    
            this.state = {
                dialog: false,
                enabled: false,
                loading:true,
                items:[],
                identification:'',
                plate:''
            };
    }

    openByDialog = () => {
        this.props.openDialog();
    }

    componentDidMount() {
        getCranes({id:0,identification:'',numberPlate:'',search:'',limit:500})
            .then((result) => {
                if(result && result.status === 200) {
                    this.setState({items:result.data.data, loading:false});
                }else{
                    this.setState({items:[], loading:false})
                }
            }).catch(error => console.log(error))
    }

    searchInput = () => {
        return (
            <div style={{display:'flex', flexDirection:'row'}}>
                <div className="relative mt-2 rounded-md shadow-sm">
                    <input
                        value={this.state.identification}
                        onChange={(e) => {this.setState({identification:e.target.value})}}
                        type="text"
                        placeholder="Buscar"
                        className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-600 sm:text-sm/6"
                        />
                </div>
                <div className="relative mt-2 rounded-md shadow-sm" style={{marginLeft:10}}>
                    <button
                        onClick={() => {this.searchValues()}}
                        type="button"
                        className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                        BUSCAR
                    </button>
                </div>
            </div>
        )
    }

    searchValues(){
        this.setState({loading:true});
        getCranes({id:0, search:this.state.identification,limit:500})
            .then((result) => {
                if(result && result.status === 200) {
                    this.setState({items:result.data.data, loading:false});
                }else{
                    this.setState({items:[], loading:false})
                }
        }).catch(error => console.log(error))
    }

    renderList() {
        return(
            <div className="px-4 sm:px-6 lg:px-8">
                <div style={{marginBottom:10}}>
                    <Breadcrumb pages={this.BreadcrumbPages}/>
                </div>
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-white font-semibold text-gray-900">.</h1>
                    </div>
                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                        <button
                            onClick={() => {this.openByDialog()}}
                            type="button"
                            className={BUTTON_LINE_ICON}>
                        <PlusCircleIcon aria-hidden="true" className="h-5 w-5 text-white-400"/>
                            NUEVA GRUA
                        </button>
                    </div>
                </div>
            
                <div className="sm:flex sm:items-center">
                {this.searchInput()}
                </div>
                {
                    this.state.loading ? 
                        <center>
                            <ClipLoader
                            color={'gray'}
                            loading={true}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"/>
                        </center>
                        :
                        <div className="mt-8 flow-root">
                        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-300">
                                    <thead className="bg-gray-50">
                                    <tr>
                                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                            Nombre
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            Identificacion
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            Placa 
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            Telefono 
                                        </th>
                                        <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                            <span className="sr-only">Edit</span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200 bg-white">
                                        {
                                            this.state.items.map((item) => {
                                                return(
                                                    <tr key={item.id}>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                            {item.name}
                                                        </td> 
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                            {item.identification}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                            {item.numberPlate}
                                                        </td>
                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                            {item.phone[0]}
                                                        </td>
                                                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                            <div style={{display:'flex', flexDirection:'row'}}>
                                                                <div style={{paddingLeft:10}}>
                                                                    <button 
                                                                        title='Actualizar informacion'
                                                                        onClick={() => {this.props.updateCrane(item)}}
                                                                        type="button"
                                                                        className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                                                                        >
                                                                        <PencilIcon aria-hidden="true" className="h-5 w-5" />
                                                                    </button>
                                                                </div>
                                                                <div style={{paddingLeft:10}}>
                                                                    <button 
                                                                        title='Ver detalles'
                                                                        onClick={() => {this.props.openDetail(item)}}
                                                                        type="button"
                                                                        className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
                                                                        <MagnifyingGlassIcon aria-hidden="true" className="h-5 w-5" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        </div>
                    </div>
                }
                    

                </div> 
        )
    }

    render(){
        return(
            <div>
                {
                    this.state.loading?
                            <center>
                                <ClipLoader
                                    color={'gray'}
                                    loading={true}
                                    size={50}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"/>
                            </center>
                    :
                        this.renderList()
                }
            </div>
        )
    }
}

export default CranesList;